import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlugin1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPlugin1"><Path d="M9.5 2H8V5.5H4V14.25C4 16.8734 6.12665 19 8.75 19H11.25V22H12.75V19H15.25C17.8734 19 20 16.8734 20 14.25V5.5H16V2H14.5V5.5H9.5V2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlugin1;
